class HikingEmbedding {
    constructor() {
        this.hikes = [...document.querySelectorAll('[data-nid]')]

        if (this.hikes.length) {
            this.hikes.forEach(el => {
                this.initEmbedding(el, el.dataset.url)
            })
        }
    }

    initEmbedding(element, url) {
        try {
            fetch(url)
                .then(response => response.json())
                .then(data => {
                    element.innerHTML = data.view

                    const currentUrl = encodeURI(window.location.href)
                    element.querySelectorAll('a')?.forEach(a => {
                        a.href = a.href.replace('windowLocation', currentUrl),
                        a.target = '_blank'
                    })
                })
        } catch (err) {
            console.error(`Failed to load embedding from ${url}:`, err)
        }
    }
}

export default HikingEmbedding